module.exports = window["wcPPCP"]["paymentMethods"];